export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    search: 'Search',
    reset: 'Reset',
    loading: 'Loading...',
    loadMore: 'Load more',
    back: 'Back',
    edit: 'Edit',
    preview: 'Preview',
    publish: 'Publish',
    off: 'Unpublish',
    official: 'Official',
    anonymous: 'Anonymous',
    share: 'Share',
    report: 'Report',
    viewAll: 'View all',
    retry: 'Retry',
    operationFailed: 'Operation failed',
    unknownError: 'Unknown error',
    loginSuccess: 'Logged in successfully',
    logoutSuccess: 'Logged out',
    createSuccess: 'Created successfully',
    saveSuccess: 'Saved successfully',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    loadFailed: 'Load failed',
    comingSoon: 'Coming soon',
    notice: 'Notice',
    requestFailed: 'Request failed',
    unauthorized: 'Unauthorized, please login again',
    forbidden: 'You do not have permission to perform this action',
    resourceNotFound: 'Resource not found',
    serverError: 'Server error',
    networkError: 'Network error, please check your connection'
  },
  router: {
    siteName: 'Hanzi Community',
    login: 'Login',
    home: 'Home',
    character: 'Character Detail',
    note: 'Note Detail',
    publish: 'Publish Note',
    topics: 'Topics',
    topic: 'Topic Detail',
    search: 'Search',
    profile: 'Profile',
    wallet: 'My Han Coins',
    words: 'Word Book',
    adminLogin: 'Admin Login',
    dashboard: 'Dashboard',
    users: 'User Management',
    roles: 'Role Management',
    permissions: 'Permission Management',
    texts: 'Content Management',
    settings: 'System Settings'
  },
  permission: {
    SUPER_ADMIN: 'Super Admin',
    ADMIN: 'Administrator',
    MODERATOR: 'Moderator',
    USER: 'User',
    unknown: 'Unknown'
  },
  time: {
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago'
  },
  frontLayout: {
    searchPlaceholder: 'Search characters, notes, topics...',
    publish: 'Publish',
    user: 'User',
    profile: 'Profile',
    wallet: 'My Han Coins',
    words: 'Word Book',
    topics: 'Topics',
    logout: 'Log out',
    login: 'Log in',
    home: 'Home',
    topic: 'Topics',
    searchNav: 'Search',
    mine: 'Me',
    logoutConfirm: 'Are you sure you want to log out?',
    logoutConfirmTitle: 'Notice'
  },
  frontLogin: {
    logoChar: '字',
    tagline: 'Discover the Beauty of Hanzi',
    subtitle: 'Share cultural essence, record your learning journey',
    featureStoryTitle: 'Share Character Stories',
    featureStoryDesc: 'Record the culture and stories behind every character',
    featureOriginTitle: 'Explore Character Origins',
    featureOriginDesc: 'Trace etymology from oracle bones to modern characters',
    featureCommunityTitle: 'Community Interaction',
    featureCommunityDesc: 'Exchange ideas with fellow learners and grow together',
    copyright: 'Hanzi Community © 2026',
    welcomeBack: 'Welcome back',
    createAccount: 'Create account',
    loginSubtitle: 'Log in to continue exploring the beauty of Hanzi',
    registerSubtitle: 'Fill in the details to start your Hanzi journey',
    login: 'Log in',
    register: 'Sign up',
    usernamePlaceholder: 'Username / Email',
    passwordPlaceholder: 'Password',
    emailPlaceholder: 'Email',
    confirmPasswordPlaceholder: 'Confirm password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    contactAdminReset: 'Please contact the administrator to reset your password',
    noAccount: 'No account yet?',
    registerNow: 'Sign up now',
    hasAccount: 'Already have an account?',
    loginNow: 'Log in now',
    thirdPartyLogin: 'Sign in with third party',
    passwordMismatch: 'The two passwords do not match',
    enterUsernameOrEmail: 'Please enter your username or email',
    enterPassword: 'Please enter your password',
    passwordMin: 'Password must be at least 8 characters',
    enterUsername: 'Please enter your username',
    usernameLength: 'Username must be 3-20 characters',
    enterEmail: 'Please enter your email',
    validEmail: 'Please enter a valid email address',
    confirmPassword: 'Please confirm your password',
    googleLoginSuccess: 'Google login successful',
    registerSuccess: 'Registered successfully, please log in',
    loginFailed: 'Login failed',
    registerFailed: 'Registration failed'
  },
  home: {
    recommend: 'Recommended',
    following: 'Following',
    hotTopics: 'Trending Topics',
    emptyTitle: 'No content yet',
    emptyDesc: 'No notes here yet, be the first to publish one',
    publishNote: 'Publish a note',
    loadFailedTitle: 'Load failed',
    loadFailedDesc: 'Something went wrong while loading, please try again',
    reload: 'Reload',
    loadMore: 'Load more',
    loading: 'Loading...',
    feedEnd: 'You have reached the end',
    todayCharacter: 'Character of the Day',
    officialPick: 'Official Pick',
    noIntro: 'No introduction yet',
    strokeCount: 'Strokes',
    radical: 'Radical',
    meaning: 'Meaning',
    viewDetail: 'View details',
    shareStory: 'Share a story too',
    quickActions: 'Quick Actions',
    browseTopics: 'Browse topics',
    searchCharacter: 'Search characters',
    trendingTopics: 'Trending Topics',
    topicsLoadFailed: 'Failed to load topics',
    noTrendingTopics: 'No trending topics yet',
    notes: 'notes'
  },
  search: {
    title: 'Search',
    placeholder: 'Search by character, pinyin, radical or strokes',
    handwritingInput: 'Handwriting',
    radicalStrokes: 'Radical & Strokes',
    characters: 'Characters',
    notes: 'Notes',
    topics: 'Topics',
    noCharacters: 'No matching characters found',
    noNotes: 'No matching notes found',
    noTopics: 'No matching topics found',
    handwritingTitle: 'Handwriting Input',
    clear: 'Clear',
    recognize: 'Recognize',
    radicalSearchTitle: 'Radical & Stroke Search',
    radical: 'Radical',
    selectRadical: 'Select radical',
    remainingStrokes: 'Remaining strokes',
    handwritingDev: 'Handwriting recognition is under development',
    radicalDev: 'Radical & stroke search is under development',
    searchFailed: 'Search failed, please try again later',
    notesCount: 'notes',
    followersCount: 'followers'
  },
  topics: {
    title: 'Topics',
    hot: 'Trending Topics',
    new: 'Latest Topics',
    official: 'Official Picks',
    officialBadge: 'Official',
    searchPlaceholder: 'Search topics...',
    createTopic: 'Create Topic',
    notes: 'notes',
    followers: 'followers',
    loadMore: 'Load more',
    createTitle: 'Create New Topic',
    nameLabel: 'Topic name',
    namePlaceholder: 'Enter a topic name, e.g. Hanzi Stories',
    descLabel: 'Description',
    descPlaceholder: 'Briefly describe this topic...',
    iconLabel: 'Topic icon',
    submit: 'Submit',
    enterName: 'Please enter a topic name',
    nameLength: 'Topic name must be 2-20 characters',
    enterDesc: 'Please enter a description',
    descLength: 'Description must be 10-100 characters',
    loadFailed: 'Failed to load topics',
    avatarFormat: 'Avatar image must be JPG/PNG format!',
    avatarSize: 'Avatar image must not exceed 2MB!',
    createSuccess: 'Topic created successfully',
    createFailed: 'Failed to create topic'
  },
  wallet: {
    title: 'My Han Coins',
    balanceLabel: 'My Han Coin balance',
    coinUnit: '',
    dailyCheckin: 'Daily check-in',
    recharge: 'Recharge',
    getCoins: 'Earn coins',
    earnTitle: 'Earn Han Coins',
    checkinTitle: 'Daily check-in',
    checkinDesc: 'Earn 1-5 coins',
    publishTitle: 'Publish a note',
    publishDesc: '+5 coins per published note',
    likeTitle: 'Receive likes',
    likeDesc: '+1 coin per like received',
    collectTitle: 'Receive collections',
    collectDesc: '+3 coins per collection',
    featuredTitle: 'Featured by official',
    featuredDesc: '+50 coins when your note is featured',
    rechargeTitle: 'Recharge Han Coins',
    coinsAmount: '{n} coins',
    rechargeNow: 'Recharge now',
    historyTitle: 'Transaction History',
    noTransactions: 'No transactions yet',
    loadFailed: 'Failed to load wallet',
    checkinSuccess: 'Check-in success +{n} coins',
    checkinFailed: 'Check-in failed',
    rechargeDev: 'Recharge is under development',
    txSignin: 'Daily check-in',
    txPublish: 'Publish note',
    txLike: 'Received a like',
    txCollect: 'Received a collection',
    txFeatured: 'Note featured',
    txRewardGiven: 'Reward given',
    txRewardReceived: 'Reward received',
    txOther: 'Coin change'
  },
  topicDetail: {
    official: 'Official',
    notes: 'notes',
    followers: 'followers',
    following: 'Following',
    followTopic: 'Follow Topic',
    hot: 'Hot',
    new: 'New',
    loadTopicFailed: 'Failed to load topic',
    loadNotesFailed: 'Failed to load notes',
    followSuccess: 'Followed successfully',
    unfollowSuccess: 'Unfollowed',
    share: 'Share',
    loadMore: 'Load more'
  },
  noteDetail: {
    back: 'Back',
    views: '{n} views',
    follow: 'Follow',
    following: 'Following',
    share: 'Share',
    report: 'Report',
    supportAuthor: 'Support the author',
    myCoins: 'My coins: {n}',
    coins: 'coins',
    reward: 'Reward',
    comments: 'All Comments ({n})',
    commentPlaceholder: 'Write a comment...',
    submitComment: 'Post comment',
    reply: 'Reply',
    replyPlaceholder: 'Write your reply...',
    reportTitle: 'Report Content',
    reasonLabel: 'Reason',
    selectReason: 'Please select a reason',
    reasonSpam: 'Spam or advertising',
    reasonFake: 'False information',
    reasonIllegal: 'Illegal or prohibited',
    reasonAbuse: 'Harassment or abuse',
    reasonOther: 'Other',
    detailLabel: 'Details',
    detailPlaceholder: 'Please describe the reason in detail',
    submit: 'Submit',
    currentUser: 'Current user',
    loadFailed: 'Failed to load note',
    loadCommentsFailed: 'Failed to load comments',
    likeSuccess: 'Liked',
    unlikeSuccess: 'Unliked',
    collectSuccess: 'Collected',
    uncollectSuccess: 'Uncollected',
    followSuccess: 'Followed',
    unfollowSuccess: 'Unfollowed',
    shareDev: 'Sharing is under development',
    selectReward: 'Please select a reward amount',
    insufficientCoins: 'Insufficient coin balance',
    rewardSuccess: 'Rewarded {n} coins',
    rewardFailed: 'Reward failed',
    enterComment: 'Please enter a comment',
    commentSuccess: 'Comment posted',
    commentFailed: 'Failed to post comment',
    enterReply: 'Please enter a reply',
    replySuccess: 'Reply posted',
    replyFailed: 'Failed to post reply',
    selectReasonPrompt: 'Please select a reason',
    reportSubmitted: 'Report submitted, we will handle it soon',
    reportFailed: 'Failed to submit report'
  },
  characterDetail: {
    commonChar: 'Common character',
    traditionalChar: 'Traditional',
    basicInfo: 'Basic Info',
    radical: 'Radical',
    strokeCount: 'Strokes',
    wuxing: 'Five Elements',
    structure: 'Structure',
    strokeAnimation: 'Stroke Animation',
    play: 'Play',
    reset: 'Reset',
    totalStrokes: 'Total strokes: {n}',
    writingTips: 'Writing tips: {tips}',
    pronunciation: 'Pronunciation',
    playPronunciation: 'Play pronunciation',
    polyphonic: 'Polyphonic Characters',
    etymology: 'Etymology',
    etymologyAnalysis: 'Etymology Analysis',
    shuowen: 'Shuowen Jiezi',
    original: 'Original text',
    translation: 'Modern translation',
    wordsIdioms: 'Words & Idioms',
    commonWords: 'Common words',
    relatedIdioms: 'Related idioms',
    communityContent: 'Community Content',
    hot: 'Hot',
    new: 'New',
    noStories: 'No one has shared a story about this character yet',
    shareFirstStory: 'Share the first story',
    loadFailed: 'Failed to load character',
    loadNotesFailed: 'Failed to load notes',
    playing: 'Playing stroke animation...',
    resetDone: 'Animation reset',
    playingSound: 'Playing pronunciation...'
  },
  publishNote: {
    title: 'Publish Note',
    titlePlaceholder: 'Enter a title',
    contentPlaceholder: 'Share stories, trivia, or memory tricks about Hanzi...',
    mediaLabel: 'Add image / video',
    uploadText: 'Click to upload media',
    uploadHint: 'Images and videos up to 60 seconds',
    linkCharacter: 'Link a character',
    searchCharacterPlaceholder: 'Search and select a character',
    topicLabel: 'Topics',
    searchTopicPlaceholder: 'Search or create a topic',
    newTopicPlaceholder: 'Enter a new topic name',
    create: 'Create',
    createNewTopic: '+ Create new topic',
    aiPolish: 'Enable AI polish (make content better)',
    aiHint: 'AI will refine your writing to make it more vivid and engaging',
    enterTitle: 'Please enter a title',
    titleTooLong: 'Title must not exceed 50 characters',
    enterContent: 'Please enter content',
    contentTooShort: 'Content must be at least 10 characters',
    selectCharacter: 'Please link at least one character',
    imageVideoOnly: 'Only image and video files are supported',
    fileTooLarge: 'File size must not exceed 10MB',
    uploadSuccess: 'Upload successful',
    enterTopicName: 'Please enter a topic name',
    topicExists: 'This topic is already added',
    topicCreated: 'Topic created',
    topicCreateFailed: 'Failed to create topic',
    publishSuccess: 'Note published!',
    publishFailed: 'Publish failed, please try again'
  },
  wordBook: {
    title: 'My Word Book',
    totalWords: 'Total words',
    todayAdded: 'Added today',
    toReview: 'To review',
    addWord: 'Add word',
    startReview: 'Start review',
    wordList: 'Word list',
    searchPlaceholder: 'Search words',
    sortByTime: 'By added time',
    sortByAlpha: 'Alphabetical',
    emptyDesc: 'Your word book is empty, go add some words!',
    addWords: 'Add words',
    basicInfo: 'Basic Info',
    pinyin: 'Pinyin',
    radical: 'Radical',
    strokeCount: 'Strokes',
    meaning: 'Meaning',
    examples: 'Examples',
    removeWord: 'Remove word',
    viewDetail: 'View details',
    reviewDev: 'Review feature is under development',
    removeConfirm: 'Are you sure you want to remove this word?',
    removeSuccess: 'Word removed',
    removeFailed: 'Failed to remove'
  },
  profile: {
    title: 'Profile',
    editProfile: 'Edit profile',
    follow: 'Follow',
    following: 'Following',
    badges: 'My Badges',
    publishedNotes: 'Published Notes',
    collectedNotes: 'Collected Notes',
    followingTab: 'Following',
    followersTab: 'Followers',
    wordBookTab: 'Word Book',
    noPublishedNotes: 'No notes published yet',
    noCollectedNotes: 'No collected notes yet',
    noFollowing: 'Not following anyone yet',
    noFollowers: 'No followers yet',
    wordBookEmpty: 'Word book is empty',
    goAddWord: 'Add words',
    addedAt: 'Added {n}',
    noBio: 'This user has nothing to say',
    loadProfileFailed: 'Failed to load profile',
    loadUserProfileFailed: 'Failed to load user profile',
    loadNotesFailed: 'Failed to load notes',
    editDev: 'Profile editing is under development',
    likes: 'Likes',
    coins: 'Coins',
    user: 'User'
  },
  adminLogin: {
    title: 'Hanzi Community · Admin',
    subtitle: 'Manage users, content and settings, keep the community in order',
    featureUserTitle: 'User Management',
    featureUserDesc: 'Manage registered users, assign roles and permissions',
    featureContentTitle: 'Content Moderation',
    featureContentDesc: 'Review notes and comments, maintain quality content',
    featureConfigTitle: 'System Configuration',
    featureConfigDesc: 'Flexibly configure site parameters and operations',
    copyright: 'Hanzi Community © 2026',
    adminLoginTitle: 'Admin Login',
    registerTitle: 'Register Account',
    loginSubtitle: 'Log in with your admin email to manage the community',
    registerSubtitle: 'Apply for an admin account to use the admin features',
    adminOnly: 'Only existing admin accounts can log in',
    emailPlaceholder: 'Admin email',
    passwordPlaceholder: 'Password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    contactSuperAdmin: 'Please contact the super administrator to reset your password',
    login: 'Log in',
    enterEmail: 'Please enter your admin email',
    validEmail: 'Please enter a valid email format',
    enterPassword: 'Please enter your password',
    passwordMin: 'Password must be at least 8 characters',
    loginFailed: 'Login failed'
  },
  adminLayout: {
    brand: 'Hanzi Community',
    searchPlaceholder: 'Search menus, users, content...',
    notifications: 'Notifications',
    profileSettings: 'Profile settings',
    systemSettings: 'System settings',
    backToFront: 'Back to front site',
    logout: 'Log out',
    dashboard: 'Dashboard',
    users: 'User Management',
    roles: 'Role Management',
    permissions: 'Permission Management',
    texts: 'Content Management',
    settings: 'System Settings',
    profileDev: 'Profile settings page is under development',
    logoutConfirm: 'Are you sure you want to log out?',
    logoutConfirmTitle: 'Confirm',
    logoutBtn: 'Log out'
  },
  dashboard: {
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
    addUser: 'Add user',
    addUserDesc: 'Create a new user account',
    roleMgmt: 'Role Management',
    roleMgmtDesc: 'Configure user roles and permissions',
    contentMgmt: 'Content Management',
    contentMgmtDesc: 'Manage notes and comments',
    systemSettings: 'System Settings',
    systemSettingsDesc: 'View and modify system configuration',
    totalUsers: 'Total Users',
    activeUsers: 'Active Users',
    totalPosts: 'Total Content',
    totalComments: 'Total Comments',
    coinCirculation: 'Coin Circulation'
  },
  users: {
    searchPlaceholder: 'Search username or email...',
    addUser: 'Add user',
    username: 'Username',
    email: 'Email',
    role: 'Role',
    admin: 'Administrator',
    moderator: 'Moderator',
    user: 'User',
    status: 'Status',
    active: 'Active',
    inactive: 'Disabled',
    createdAt: 'Registered At',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    nameLabel: 'Name',
    namePlaceholder: 'Enter a name',
    roleLabel: 'Role',
    selectRole: 'Select a role',
    statusLabel: 'Status',
    selectStatus: 'Select a status',
    addTitle: 'Add User',
    editTitle: 'Edit User',
    deleteConfirm: 'Are you sure you want to delete user "{name}"? This cannot be undone.',
    deleteConfirmTitle: 'Confirm Delete',
    deleteSuccess: 'User deleted',
    updatedSuccess: 'User updated',
    createdSuccess: 'User created',
    initialPassword: 'Initial password: {pwd}',
    createSuccessTitle: 'Created',
    gotIt: 'Got it',
    enterName: 'Please enter a name',
    enterEmail: 'Please enter an email',
    validEmail: 'Please enter a valid email format',
    selectRoleRequired: 'Please select a role',
    selectStatusRequired: 'Please select a status'
  },
  roles: {
    searchPlaceholder: 'Search role names...',
    addRole: 'Add role',
    name: 'Role name',
    code: 'Role code',
    description: 'Description',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    actions: 'Actions',
    edit: 'Edit',
    permissions: 'Permissions',
    delete: 'Delete',
    nameLabel: 'Name',
    namePlaceholder: 'Enter a role name',
    codeLabel: 'Code',
    codePlaceholder: 'e.g. admin, editor',
    descLabel: 'Description',
    descPlaceholder: 'Role description',
    statusLabel: 'Status',
    permDialogTitle: 'Assign Permissions',
    addTitle: 'Add Role',
    editTitle: 'Edit Role',
    deleteConfirm: 'Are you sure you want to delete role "{name}"?',
    deleteSuccess: 'Role deleted',
    saveSuccess: 'Saved successfully',
    permsUpdated: 'Permissions updated',
    enterName: 'Please enter a role name',
    enterCode: 'Please enter a role code',
    selectStatus: 'Please select a status'
  },
  permissions: {
    title: 'Permission List',
    addPerm: 'Add permission',
    name: 'Permission name',
    code: 'Permission code',
    type: 'Type',
    menu: 'Menu',
    button: 'Button',
    api: 'API',
    path: 'Path',
    sort: 'Sort',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    parentPerm: 'Parent permission',
    selectParent: 'Select parent (optional)',
    nameLabel: 'Name',
    namePlaceholder: 'Enter a permission name',
    codeLabel: 'Code',
    codePlaceholder: 'e.g. user:create',
    typeLabel: 'Type',
    sortLabel: 'Sort',
    pathLabel: 'Path',
    statusLabel: 'Status',
    addTitle: 'Add Permission',
    editTitle: 'Edit Permission',
    deleteConfirm: 'Are you sure you want to delete permission "{name}"?',
    deleteConfirmTitle: 'Confirm Delete',
    deleteSuccess: 'Deleted',
    saveSuccess: 'Saved successfully',
    enterName: 'Please enter a permission name',
    enterCode: 'Please enter a permission code',
    selectType: 'Please select a type',
    selectStatus: 'Please select a status'
  },
  settings: {
    general: 'General Settings',
    siteName: 'Site name',
    siteUrl: 'Site URL',
    adminEmail: 'Admin email',
    timezone: 'Timezone',
    save: 'Save settings',
    reset: 'Reset',
    security: 'Security Settings',
    twoFactor: 'Enable two-factor authentication',
    sessionTimeout: 'Session timeout (minutes)',
    passwordMinLen: 'Minimum password length',
    forcePwdChange: 'Force periodic password change',
    notifications: 'Notification Settings',
    emailNotif: 'Email notifications',
    smsNotif: 'SMS notifications',
    pushNotif: 'Push notifications',
    notifEmail: 'Notification email',
    generalSaved: 'General settings saved',
    securitySaved: 'Security settings saved',
    notifSaved: 'Notification settings saved',
    saveFailed: 'Failed to save'
  },
  textManagement: {
    searchPlaceholder: 'Search by title or content...',
    allStatus: 'All statuses',
    published: 'Published',
    draft: 'Draft',
    deleted: 'Deleted',
    title: 'Title',
    author: 'Author',
    likes: 'Likes',
    comments: 'Comments',
    createdAt: 'Created At',
    status: 'Status',
    actions: 'Actions',
    preview: 'Preview',
    publish: 'Publish',
    offline: 'Unpublish',
    delete: 'Delete',
    previewTitle: 'Content Preview',
    loadFailed: 'Failed to load content list',
    confirmTitle: 'Confirm Action',
    statusConfirm: 'Are you sure you want to {action} "{title}"?',
    statusSuccess: '{action} successful',
    statusFailed: '{action} failed',
    deleteConfirm: 'Are you sure you want to delete "{title}"? This cannot be recovered.',
    deleteConfirmTitle: 'Confirm Delete',
    deleteSuccess: 'Deleted'
  }
}